import React, { useState } from 'react';
import { askChatGPT } from '../api/chatgpt';
import Button from './common/Button';
import { t } from '../i18n';

const Chat = () => {
  const [messages, setMessages] = useState([
    { role: 'system', content: 'You are a helpful assistant for analyzing project data.' },
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!input.trim()) return;

    const newMessages = [...messages, { role: 'user', content: input }];
    setMessages(newMessages);
    setInput('');
    setLoading(true);

    try {
      const response = await askChatGPT(newMessages);
      setMessages([...newMessages, { role: 'assistant', content: response }]);
    } catch (error) {
      setMessages([...newMessages, { role: 'assistant', content: 'Error: Unable to fetch response.' }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-[420px]">
      <div className="flex-1 overflow-y-auto p-3 space-y-2">
        {messages.map((msg, index) => (
          <div
            key={index}
            className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}
          >
            <div
              className={`max-w-[85%] rounded px-3 py-2 text-sm ${
                msg.role === 'user'
                  ? 'bg-brand-600 text-white'
                  : msg.role === 'system'
                  ? 'bg-neutral-50 text-neutral-400 italic'
                  : 'bg-neutral-100 text-neutral-700'
              }`}
            >
              {t(msg.content)}
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center gap-2 p-2 border-t border-neutral-200">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={t('Ask about project data...')}
          className="flex-1 h-8 px-2.5 text-sm border border-neutral-300 rounded focus:outline-none focus:ring-1 focus:ring-brand-400 focus:border-brand-400"
        />
        <Button variant="primary" size="sm" onClick={handleSend} disabled={loading}>
          {loading ? t('Sending...') : t('Send')}
        </Button>
      </div>
    </div>
  );
};

export default Chat;
